<template>
  <v-dialog v-model="showModal" fullscreen persistent>
    <v-card>
      <v-toolbar dark class="primary">
        <v-btn icon @click.native="showModal = false" dark>
          <v-icon>fa-times</v-icon>
        </v-btn>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-form v-show="!loading" @submit.prevent="handleSubmit" data-vv-scope="mainForm" :class="visibility_class">
          <v-tabs grow v-model="active_tab" slider-color="primary">
            <v-tab ripple>Ogólne</v-tab>
            <v-tab ripple v-if="visitid > 0">Opłaty</v-tab>
            <v-tab ripple v-if="visitid > 0 && $can('do', 'POKO_Wizyty_Edycja_Przebiegu')">Przebieg
              wizyty</v-tab>
            <v-tab ripple v-if="visitid > 0">SMS</v-tab>
            <v-tab ripple v-if="visitid > 0 && !hidevisithistory">Historia wizyt</v-tab>
            <v-tab ripple v-if="visitid > 0 && $can('do', 'POKO_KlienciProblemy')">Problemy pacjenta</v-tab>
            <v-tab ripple
              v-show="visitid && visitid > 0 && isAttachementsEnabled && $can('do', 'POKO_Klienci_Zalaczniki_Przegladanie')">Załączniki
              pacjenta</v-tab>
            <v-tab ripple v-if="visitid > 0 && clientId > 0 && $can('do', 'POKO_Podpisy')">Podpisy</v-tab>
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <v-container fluid grid-list-xl>
                    <v-row>
                      <v-col cols="12" sm="12" md="4">
                        <v-menu ref="dateMenu" v-model="dateMenu" :close-on-content-click="false" :nudge-right="40"
                          :return-value.sync="date" transition="scale-transition" offset-y min-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field v-model="date" label="Data wizyty" prepend-icon="fa-calendar-alt" id="date"
                              name="date" readonly v-validate="'required'"
                              :error-messages="errors.collect('mainForm.date')" data-vv-as="Data wizyty"
                              v-on="on"></v-text-field>
                          </template>
                          <v-date-picker v-model="date" no-title scrollable locale="pl-PL">
                            <v-spacer></v-spacer>
                            <v-btn color="primary" @click="dateMenu = false">Anuluj
                            </v-btn>
                            <v-btn color="primary" @click="$refs.dateMenu.save(date)">
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        <TimePicker v-model="startTime" text="Początek" :disabled="readonly"
                          :timeScale="settings.calendarTimeScale">
                        </TimePicker>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        <TimePicker v-model="endTime" text="Koniec" :disabled="readonly" :minTime="startTime"
                          :timeScale="settings.calendarTimeScale"></TimePicker>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="6">
                        <v-container fluid>
                          <v-row>
                            <v-col cols="10">
                              <v-autocomplete v-model="clientId" id="clientId" name="clientId"
                                :loading="isLoadingClients" :items="clientsList" :search-input.sync="clientKeyword"
                                cache-items flat :readonly="readonly" no-data-text="Nieznaleziono" hide-details
                                v-validate="'required'" :error-messages="errors.collect('mainForm.clientId')"
                                data-vv-as="Pacjent" item-value="id" item-text="full_text" prepend-icon="fa-search"
                                label="Wyszukaj pacjenta Imię/Nazwisko/PESEL/Numer Telefonu">
                                <template v-slot:selection="data">
                                  <v-container fluid>
                                    <v-row no-gutters>
                                      <v-col cols="12" sm="12" md="3">
                                        {{ data.item.name + ' ' + data.item.surname }}
                                      </v-col>
                                      <v-col cols="12" sm="12" md="3" v-if="data.item.description">
                                        {{ data.item.description != null ? data.item.description.substr(0, 19) : '' }}
                                      </v-col>
                                      <v-col cols="12" sm="12" md="3" v-if="data.item.pesel">
                                        {{ data.item.pesel }}
                                      </v-col>
                                      <v-col cols="12" sm="12" md="3" v-if="data.item.phone">
                                        <v-icon class="mr-2">fa-phone</v-icon>{{ data.item.phone }}
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </template>
                                <template v-slot:item="data">
                                  <v-container fluid>
                                    <v-row no-gutters>
                                      <v-col cols="12" sm="12" md="3">
                                        {{ data.item.name + ' ' + data.item.surname }}
                                      </v-col>
                                      <v-col cols="12" sm="12" md="3" v-if="data.item.description">
                                        {{ data.item.description != null ? data.item.description.substr(0, 19) : '' }}
                                      </v-col>
                                      <v-col cols="12" sm="12" md="3" v-if="data.item.pesel">
                                        {{ data.item.pesel }}
                                      </v-col>
                                      <v-col cols="12" sm="12" md="3" v-if="data.item.phone">
                                        <v-icon class="mr-2">fa-phone</v-icon>{{ data.item.phone }}
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </template>
                              </v-autocomplete>
                            </v-col>
                            <v-col cols="2" align-self="center">
                              <v-btn fab small color="primary" @click="quickAddClient"
                                v-if="$can('do', 'POKO_Klienci_Edycja')">
                                <v-icon>fa-plus</v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-container fluid>
                          <v-row>
                            <v-col cols="12">
                              <v-autocomplete v-model="therapistId" id="therapistId" name="therapistId"
                                :loading="isLoadingTherapists" :items="therapists" flat
                                :readonly="zmiana_pracownika_enabled" hide-details v-validate="'required'"
                                :error-messages="errors.collect('mainForm.therapistId')" data-vv-as="Terapeuta"
                                item-text="name" item-value="id" prepend-icon="fa-search"
                                label="Wyszukaj terapeute Imię/Nazwisko">
                                <template v-slot:item="data">
                                  <div>{{ data.item.name + (data.item.reason ? ' (' + data.item.reason + ')' : '') }}
                                  </div>
                                </template>
                                <template v-slot:selection="data">
                                  <div>{{ data.item.name + (data.item.reason ? ' (' + data.item.reason + ')' : '') }}
                                  </div>
                                </template>
                              </v-autocomplete>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="12" md="6">
                        <v-select :items="availableRooms" :readonly="(status == 3)" clearable label="Gabinet"
                          placeholder="Wybierz gabinet.." v-model="roomId" name="roomId" id="roomId">
                        </v-select>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" v-if="this.features.IntegracjaP1">
                        <v-select :items="organizational_units" :readonly="(status == 3)" item-text="nazwa"
                          v-validate="'required'" label="Komórka organizacyjna"
                          placeholder="Wybierz komórkę organizacyjna..." v-model="organizational_unit" return-object
                          :error-messages="errors.collect('mainForm.organizational_unit')"
                          data-vv-as="Kamórka organizacyjna" name="organizational_unit"
                          id="organizational_unit"></v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="12" md="6" v-if="wybrany_zabieg || zabieg">
                        <v-select :items="filteredzabiegi" item-text="nazwa" v-validate="'required'" label="Zabieg"
                          placeholder="Wybierz zabieg..." v-model="wybrany_zabieg" return-object
                          :error-messages="errors.collect('mainForm.zabieg')" data-vv-as="Zabieg" name="zabieg"
                          id="zabieg" :disabled="!zabieg"></v-select>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" v-if="wybrany_zabieg && wybrany_zabieg.podtypy">
                        <v-select :items="filteredpodtypy" item-text="nazwa" label="Podtyp"
                          placeholder="Wybierz podtyp zabiegu..." v-model="wybrany_podtyp" return-object
                          :disabled="!zabieg"></v-select>
                      </v-col>
                    </v-row>
                    <v-row v-if="!zabieg && therapistId > 0 && filteredtypywizyt.length > 0">
                      <v-col cols="12" sm="12" md="6">
                        <v-select :items="filteredtypywizyt" item-text="nazwa" label="Typ wizyty terapeuty"
                          placeholder="Wybierz typ wizyty_terapeuty..." v-model="wybrany_typ_wizyty" return-object
                          clearable :disabled="status >= 2">
                          <template v-slot:selection="data">
                            <div>{{ data.item.nazwa + ' - ' + data.item.cena + ' zł' }}</div>
                          </template>
                          <template v-slot:item="data">
                            <div>{{ data.item.nazwa + ' - ' + data.item.cena + ' zł' }}</div>
                          </template>
                        </v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="12" md="6">
                        <v-text-field label="Data urodzenia"
                          :value="birthDate ? birthDate.toLocaleDateString() : 'Nieznana'" readonly></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <v-text-field label="Wiek" :value="age !== null ? age + ' lat' : 'Nieznany'"
                          readonly></v-text-field>
                      </v-col>
                      <v-col cols="6" sm="6" md="2" v-if="settings.allowRegularVisits">
                        <v-switch inset v-model="regularVisit" label="Wizyta cykliczna"
                          :readonly="(status == 3)"></v-switch>
                      </v-col>
                      <v-col cols="6" sm="6" md="3" v-if="regularVisit && visitid == 0">
                        <v-select v-model="regularVisitSelectedPeriod" clearable item-text="name" return-object
                          :items="regularVisitPeriods" label="Powtarza wizytę co:" :readonly="(status == 3)"></v-select>
                      </v-col>
                      <v-col cols="6" sm="6" md="3" v-if="regularVisit && visitid == 0">
                        <DatePicker v-model="periodEndDate" pickerLabel="Data zakończenia" :readonly="(status == 3)">
                        </DatePicker>
                      </v-col>
                      <v-col cols="6" sm="6" md="1" v-if="regularVisit && visitid == 0 && regularVisitSelectedPeriod"
                        align-self="center">
                        <v-btn color="primary" @click="checkRegularVisit">Weryfikuj</v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" v-if="therapistId > 0 && settings.showAdditionalTherapistsForVisitCreation">
                        <VisitEditorAdditionalTherapists :initialTherapists="additionalTherapists"
                          :mainTherapistId="therapistId" @therapists-updated="updateAdditionalTherapists"
                          :fullTherapistList="fullTherapistListForAdditionalTherapists" :typywizyt="typywizyt" />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <tiptap-vuetify v-model="notes" label="Uwagi do wizyty:" :extensions="extensions" name="notes"
                          :readonly="(status == 3)" id="notes" />
                      </v-col>
                    </v-row>
                    <v-row v-if="notesForReception">
                      <v-textarea name="notes_for_Reception" readonly outline v-model="notesForReception"></v-textarea>
                    </v-row>
                    <v-row v-if="isFromPortal && visitid > 0">
                      <v-col cols="12">
                        <v-alert :type="portalStatus === 1 ? 'warning' : 'info'" prominent>
                          <v-row align="center">
                            <v-col class="grow">
                              <v-icon left>fa-globe</v-icon>
                              <strong>Wizyta z Portalu Pacjenta</strong>
                              <span v-if="portalStatus === 1"> - oczekuje na potwierdzenie</span>
                              <span v-else-if="portalStatus === 2"> - potwierdzona</span>
                              <span v-else-if="portalStatus === 3"> - anulowana</span>
                            </v-col>
                            <v-col class="shrink d-flex flex-wrap" v-if="portalStatus === 1 && $can('do', 'POKO_Wizyty_Edycja')">
                              <v-btn color="success" class="mr-2 mb-2" @click="confirmPortalVisit" :loading="portalLoading">
                                <v-icon left>fa-check</v-icon>
                                Potwierdź
                              </v-btn>
                              <v-btn color="error" class="mb-2" @click="cancelPortalVisit" :loading="portalLoading">
                                <v-icon left>fa-times</v-icon>
                                Odrzuć
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-alert>
                      </v-col>
                    </v-row>
                    <v-row v-if="visitid > 0">
                      <v-col cols="12" sm="12" md="6">
                        <v-switch inset v-model="obecny" :label="obecny_text" @change="obecnoscChange"></v-switch>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <v-switch inset v-model="nie_wysylaj_sms" :label="nie_wysylaj_sms_text"
                          @change="nieWysylajChange"></v-switch>
                      </v-col>

                    </v-row>
                    <v-row v-if="status == 2">
                      <v-col cols="12">
                        <v-alert type="warning" prominent>
                          Wizyta została odwołana. Status: {{ getStatusDescription() }} {{ cancelReason ? 'Powód: ' +
                            cancelReason : '' }}
                        </v-alert>
                      </v-col>
                    </v-row>
                    <v-row v-if="zaproszenie_sms_payu && zaproszenie_sms_payu.payUExpired">
                      <v-col cols="12">
                        <v-alert type="warning" prominent>
                          Zaproszenie PayU wygasło.
                        </v-alert>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item v-if="visitid > 0">
              <v-card flat>
                <v-card-text>
                  <v-container flud>
                    <v-row>
                      <v-col cols="12">
                        <v-card>
                          <v-data-table hide-default-footer :headers="paymentHeaders" :no-data-text="'Brak danych'"
                            :items="payments" disable-pagination class="elevation-1">
                            <template v-slot:item.payAmount="{ item }">
                              {{ getPaymentAmount(item) }}
                            </template>
                            <template v-slot:item.type="{ item }">
                              {{ getPaymentType(item) }}
                            </template>
                            <template v-slot:item.paymentDate="{ item }">
                              {{ item.paymentDate ? dateFormat(item.paymentDate) : '' }}
                            </template>
                            <template v-slot:item.id="{ item }">
                              <v-layout align-center>
                                <v-icon small
                                  v-if="$can('do', 'POKO_Wizyty_Platnosci_Edycja') && status != 3 && item.type != 3 && item.type != 4 && item.type != 6"
                                  @click="editPayment(item.id)" title="Edytuj">
                                  fa-edit
                                </v-icon>
                                <v-icon small
                                  v-if="$can('do', 'POKO_Wizyty_Platnosci_Usuwanie') && status != 3 && item.type != 6"
                                  @click="deletePayment(item.id)" itle="Usuń">
                                  fa-trash-alt
                                </v-icon>
                                <v-icon
                                  v-if="item.type == 6 && !item.payURefunded && item.refundEnabled && $can('do', 'POKO_PayU_PrzegladPlatnosciZwroty')"
                                  small class="mr-2" @click="refund(item)" color="primary"
                                  title="Zwróć płatność">fa-undo</v-icon>
                              </v-layout>
                            </template>
                          </v-data-table>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-row v-if="this.features.Fizykoterapia">
                      <v-col cols="12">
                        <v-card>
                          <v-card-title>Podsumowanie wizyt z dnia: {{ date }}</v-card-title>
                          <v-card-text>
                            <v-data-table hide-default-footer :headers="podsumowanieHeaders"
                              :no-data-text="'Brak danych'" :items="podsumowanie" disable-pagination
                              class="elevation-1">
                              <template v-slot:item="props">
                                <tr>
                                  <td>{{ props.item.nazwa }}</td>
                                  <td>{{ props.item.podtyp }}</td>
                                  <td>{{ dateTimeFormat(props.item.start) }}</td>
                                  <td>{{ props.item.dlugoscWizyty }}</td>
                                  <td>{{ props.item.cena }}</td>
                                  <td>{{ props.item.terapeuta }}</td>
                                </tr>
                              </template>
                              <template slot="body.append">
                                <tr>
                                  <th>Suma:</th>
                                  <th></th>
                                  <th></th>
                                  <th></th>
                                  <th>{{ podsumowanie_suma }}</th>
                                  <th></th>
                                </tr>
                              </template>
                            </v-data-table>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" v-if="status != 3">
                        <v-card>
                          <v-card-text>
                            <v-container fluid>
                              <v-row>
                                <v-col cols="12" sm="12" md="4" align-self="end">
                                  <v-text-field label="Opłata" name="payAmount" :readonly="status == 3"
                                    v-validate="'decimal'" data-vv-as="Opłata" min="0" id="payAmount"
                                    v-model.number="payAmount" step="0.01" type="number"
                                    :error-messages="errors.collect('mainForm.payAmount')">
                                    >
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="2" align-self="end">
                                  <v-radio-group v-model="paymentType" :readonly="status == 3">
                                    <v-radio :value="0" label="Gotówka"></v-radio>
                                    <v-radio :value="1" label="Karta"></v-radio>
                                    <v-radio :value="2" label="Przelew"></v-radio>
                                    <v-radio :value="3" label="Kredyt" v-if="kredyt"></v-radio>
                                    <v-radio :value="5" label="Inne"></v-radio>
                                  </v-radio-group>
                                </v-col>
                                <v-col cols="12" sm="12" md="4" v-if="paymentType == 3" align-self="end">
                                  <v-card elevation="1">
                                    <v-card-text>
                                      <p>Aktualne saldo: {{ aktualne_saldo }}</p>
                                      <p>Limit: {{ limit_kredytu }}zł</p>
                                      <p v-if="waznosc_kredytu">Ważność kredytu do:
                                        {{ getFormattedDateWithoutTime(waznosc_kredytu) }}</p>
                                    </v-card-text>
                                  </v-card>
                                </v-col>
                                <v-col cols="12" sm="12" md="4" align-self="end">
                                  <v-menu v-model="paymentDateMenu" :close-on-content-click="false" :nudge-right="40"
                                    transition="scale-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field v-model="paymentDate" label="Data płatności"
                                        prepend-icon="fa-calendar" readonly v-bind="attrs" v-on="on"
                                        :disabled="status == 3 || paymentType !== 2"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="paymentDate" @input="paymentDateMenu = false"
                                      :disabled="status == 3 || paymentType !== 2"></v-date-picker>
                                  </v-menu>
                                </v-col>
                                <v-col cols="12" sm="12" md="3" align-self="end">
                                  <v-btn color="primary" :disabled="disableAddPayment" @click="addPayment"
                                    v-if="$can('do', 'POKO_Wizyty_Edycja') && visitid > 0 && status != 2">
                                    Dodaj płatność
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-row v-if="voucherList && voucherList.length > 0">
                      <v-col cols="12">
                        <v-card>
                          <v-card-text>
                            <v-container fluid>
                              <v-row>
                                <v-col cols="12" lg="6" md="6" sm="12">
                                  <v-container fluid>
                                    <v-row>
                                      <v-col cols="12">
                                        <v-select v-model="wybrany_voucher" :items="voucherList"
                                          label="Dostępne vouchery" :readonly="status == 3" item-text="nazwa_numer"
                                          return-object clearable></v-select>
                                      </v-col>
                                      <v-col cols="12" v-if="wybrany_voucher && wybrany_voucher.typ == 2">
                                        <v-text-field label="Wartość do pobrania z vouchera" :readonly="status == 3"
                                          min="0" v-model.number="voucherPayAmount" step="0.01" type="number">
                                        </v-text-field>
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-col>
                                <v-col cols="12" lg="6" md="6" sm="12" v-if="wybrany_voucher">
                                  <table class="simple_table">
                                    <tbody>
                                      <tr>
                                        <td>Nazwa:</td>
                                        <td>{{ wybrany_voucher.nazwa }}</td>
                                      </tr>
                                      <tr>
                                        <td>Typ vouchera:</td>
                                        <td>{{ getTypOpis(wybrany_voucher.typ) }}</td>
                                      </tr>
                                      <tr>
                                        <td>{{ getWykorzystanieOpis(wybrany_voucher.typ) }}</td>
                                        <td>{{ getWykorzystaneWartosci(wybrany_voucher) }}</td>
                                      </tr>
                                      <tr v-if="wybrany_voucher.kiedy_wygasa">
                                        <td>Wygasa:</td>
                                        <td>{{ dateFormat(wybrany_voucher.kiedy_wygasa) }}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </v-col>
                              </v-row>

                              <v-row>
                                <v-col cols="12" class="text-right">
                                  <v-btn color="primary" @click="addPaymentVoucher"
                                    :disabled="wybrany_voucher == null || disableAddPayment"
                                    v-if="$can('do', 'POKO_Wizyty_Edycja') && visitid > 0">
                                    Dodaj płatność
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item v-if="visitid > 0 && $can('do', 'POKO_Wizyty_Edycja_Przebiegu')">
              <VisitProcess v-if="$can('do', 'POKO_Wizyty_Edycja_Przebiegu')" :recognition.sync="recognition"
                :allowedit="$can('do', 'POKO_Wizyty_Edycja_Przebiegu')" :recommendations.sync="recomendations"
                :process.sync="process" :visitid.sync="visitid" :procedures.sync="visitProcedures"
                :conditions.sync="visitConditions" />
            </v-tab-item>
            <v-tab-item v-if="visitid > 0">
              <!--<v-container fluid>
                <v-row no-gutters>
                  <p>SMS'a nadano: <span>{{ getFormattedDate(smsData.insertTime) }}</span></p>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-textarea readonly label="Treść nadanego smsa:" :value="smsData.smsText"></v-textarea>
                  </v-col>
                </v-row>
                <v-row no-gutters v-if="smsData.responseItems && smsData.responseItems.length > 0">
                  <v-col cols="12">
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">Numer telefonu</th>
                            <th class="text-left">Czas nadania</th>
                            <th class="text-left">Treść</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item in smsData.responseItems" :key="item.id">
                            <td>{{ item.phoneNumber }}</td>
                            <td>{{ getFormattedDate(item.dateReceived) }}</td>
                            <td>{{ item.text }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                    <v-textarea readonly :label="'Odpowiedź z numeru: '+smsData.phoneNumber"
                                                    :value="smsData.response"></v-textarea>

                  </v-col>
                </v-row>
              </v-container>-->
              <ClientSMS :clientid="clientId" :visitid="visitid" />
            </v-tab-item>
            <v-tab-item v-if="visitid > 0 && !hidevisithistory">
              <v-container fluid>
                <v-row>
                  <v-col cols="12">
                    <v-card>
                      <v-card-title>Historia wizyt</v-card-title>
                      <v-card-text>
                        <MedicalVisitHistory :hideprocess="visitid > 0" :clientid="clientId">
                        </MedicalVisitHistory>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-card>
                      <v-card-title>Zmiany terminu</v-card-title>
                      <v-card-text>
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left">Kto zmienił</th>
                                <th class="text-left">Data zmiany terminu</th>
                                <th class="text-left">Poprzednia data wizyty</th>
                                <th class="text-left">Poprzednie godziny wizyty</th>
                                <th class="text-left">Aktualna data wizyty</th>
                                <th class="text-left">Aktualne godziny wizyty</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="item in visitShifts" :key="item.id">
                                <td>{{ item.creator }}</td>
                                <td>{{ getFormattedDate(item.shiftDate) }}</td>
                                <td>{{ item.oldDate }}</td>
                                <td>{{ item.oldHours }}</td>
                                <td>{{ item.currentDate }}</td>
                                <td>{{ item.currentHours }}</td>

                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>


            </v-tab-item>
            <v-tab-item v-if="visitid > 0 && $can('do', 'POKO_KlienciProblemy')">
              <Problemy :clientid="clientId"></Problemy>
            </v-tab-item>
            <v-tab-item
              v-if="visitid && visitid > 0 && isAttachementsEnabled && $can('do', 'POKO_Klienci_Zalaczniki_Przegladanie')">
              <v-card flat>
                <v-card-text>
                  <ClientAttachments :client="clientId"></ClientAttachments>
                </v-card-text>
              </v-card>

            </v-tab-item>
            <v-tab-item v-if="visitid > 0 && clientId > 0 && $can('do', 'POKO_Podpisy')">
              <v-card flat>
                <v-card-text>
                  <ClientSignatures :client="clientId" :clientName="selectedClientName" :fromVisit="true"></ClientSignatures>
                </v-card-text>
              </v-card>
            </v-tab-item>

          </v-tabs>
        </v-form>
      </v-card-text>
      <v-card-actions v-show="!loading" class="d-flex flex-wrap gap-2 pa-0 ma-0">
        <v-btn @click="closeForm" color="error">Anuluj</v-btn>
        <v-btn color="success" @click="handleSubmit"
          v-if="$can('do', 'POKO_Wizyty_Edycja') && status != 3 && status != 2">
          Zapisz
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="openVisit" v-if="$can('do', 'POKO_Wizyty_Otwarcie') && status == 3">Otwórz
          wizyte ponownie
        </v-btn>
        <v-btn color="success" style="color:white" @click="showZaproszenieSMS"
          v-if="(status == 0 || status == 4 || status == 5) && visitid > 0">
          Zaproszenie SMS
        </v-btn>
        <v-btn color="success darken-4" style="color:white" @click="showZaproszenieSMSPayU"
          v-if="(status == 0 || status == 4 || status == 5) && visitid > 0 && $can('do', 'POKO_Wizyty_Edycja') && this.features.PayU">
          Zaproszenie SMS (PayU)
        </v-btn>
        <v-btn color="purple" style="color:white" @click="confirmVisit"
          v-if="(status == 0 || status == 4 || status == 5) && visitid > 0 && $can('do', 'POKO_Wizyty_Edycja')">
          Wizyta potwierdzona
        </v-btn>
        <v-btn color="primary" @click="closeVisit"
          v-if="((status == 0 || status == 1 || status == 4 || status == 5) && visitid > 0 && $can('do', 'POKO_Wizyty_Edycja'))">
          Zamknij wizyte
        </v-btn>
        <v-btn color="orange darken-2" style="color:white" @click="cancelVisit"
          v-if="((status == 0 || status == 1 || status == 4 || status == 5) && visitid > 0 && $can('do', 'POKO_Wizyty_Edycja'))">
          Odwołaj wizyte
        </v-btn>
        <v-btn color="success darken-2" style="color:white" @click="showVerify = true"
          v-if="((status == 0 || status == 1 || status == 4 || status == 5) && visitid > 0 && $can('do', 'POKO_Wizyty_Edycja'))">
          Zweryfikuj dane do P1
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="reasonDialog" persistent max-width="500px">
      <v-card>
        <v-card-title>
          Anulowanie wizyty - dodatkowe informacje
        </v-card-title>
        <v-card-text>
          <v-container fluid>
            <v-row v-if="regularVisit">
              <v-col cols="12">
                <v-alert type="warning">
                  Anulowanie wizyty cyklicznej spowoduje anulowanie wszystkich wizyt w tym cyklu.
                </v-alert>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-select label="Wybierz powód" v-model="reason" :items="cancelSubtypes" item-text="name" return-object>
                </v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field label="Notatki" v-model="reasonNotes"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="saveCancel">Zapisz</v-btn>
          <v-btn color="error" @click="reasonDialog = false">Anuluj</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editPaymentDialog" persistent max-width="500px" v-if="$can('do', 'POKO_Wizyty_Edycja')">
      <v-card>
        <v-card-title>
          Edycja zapłaty
        </v-card-title>
        <v-card-text>
          <v-form data-vv-scope="editPaymentForm">
            <v-container fluid>
              <v-row>
                <v-col xs6>
                  <v-text-field label="Opłata" name="editPaymentAmount" :readonly="status == 3" v-validate="'decimal'"
                    data-vv-as="Opłata" min="0" id="editPaymentAmount" v-model.number="editPaymentAmount" step="0.01"
                    type="number" :error-messages="errors.collect('editPaymentForm.editPaymentAmount')">
                    >
                  </v-text-field>
                </v-col>
                <v-col xs6>
                  <v-radio-group v-model="editPaymentType" :readonly="status == 3">
                    <v-radio :value="0" label="Gotówka"></v-radio>
                    <v-radio :value="1" label="Karta"></v-radio>
                    <v-radio :value="2" label="Przelew"></v-radio>
                    <v-radio :value="5" label="Inne"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row>
                <v-col xs12>
                  <DatePicker v-model="editPaymentDate" :readonly="status == 3 || editPaymentType !== 2" />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="updateVisitPayment">Zapisz</v-btn>
          <v-btn color="error" @click="editPaymentDialog = false">Anuluj</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="regularVisitDialog" max-width="720px" v-if="regularVisitDialog && regularVisitData">
      <RegularVisitDates :visitData="regularVisitData" @close="onCloseRegularVisitDialog"
        :typWizytyId="wybrany_typ_wizyty != null ? wybrany_typ_wizyty.id : null" :therapistId="therapistId"
        @save="onSaveRegularVisit" :currentDatesStatuses="datesStatus"></RegularVisitDates>
    </v-dialog>
    <v-dialog v-model="addQuickClientDialog" max-width="500px" v-if="$can('do', 'POKO_Klienci_Edycja')">
      <QuickAddClient title="Dodawanie pacjenta" @close="addQuickClientDialog = false" @success="saveQuickClient">
      </QuickAddClient>
    </v-dialog>
    <v-dialog v-model="showZaproszenieDialog" width="500px">
      <v-card>
        <v-toolbar dark class="primary">
          <v-btn icon @click.native="showZaproszenieDialog = false" dark>
            <v-icon>fa-times</v-icon>
          </v-btn>
          <v-toolbar-title>Zaproszenie na wizyte {{ zaproszenie_show_payu ? '(PayU)' : '' }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container fluid v-if="!zaproszenie_show_payu">
            <v-row>
              <v-col cols="12" v-if="!zaproszenie_sms">
                <span class="headline">Zaproszenia jeszcze nie wysłano</span>
              </v-col>
              <v-col cols="12" v-if="zaproszenie_sms">
                <v-container fluid>
                  <v-row no-gutters>
                    <v-col cols="12">
                      <p>SMS'a nadano: <span>{{ getFormattedDate(zaproszenie_sms.insertTime) }}</span></p>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="12">
                      <v-textarea readonly label="Treść nadanego smsa:" :value="zaproszenie_sms.smsText"></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="12">
                      <p>Status: <span>{{ getSMSStatus(zaproszenie_sms.status) }}</span></p>
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>
            </v-row>
          </v-container>
          <v-container fluid v-else>
            <v-row>
              <v-col cols="12" v-if="!zaproszenie_sms_payu">
                <span class="headline">Zaproszenia jeszcze nie wysłano</span>
              </v-col>
              <v-col cols="12" v-if="zaproszenie_sms_payu">
                <v-container fluid>
                  <v-row no-gutters>
                    <v-col cols="12">
                      <p>SMS'a nadano: <span>{{ getFormattedDate(zaproszenie_sms_payu.insertTime) }}</span></p>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="12">
                      <v-textarea readonly label="Treść nadanego smsa:"
                        :value="zaproszenie_sms_payu.smsText"></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="12">
                      <p>Status: <span>{{ getSMSStatus(zaproszenie_sms_payu.status) }}</span></p>
                    </v-col>
                  </v-row>
                  <v-row v-if="zaproszenie_sms_payu.payUExpired">
                    <v-col cols="12">
                      <v-alert type="warning">
                        Link PayU wygasł.
                      </v-alert>
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="sendInvitationSMS"
            v-if="!zaproszenie_show_payu && (zaproszenie_sms == null || zaproszenie_sms.status !== 0)">Wyślij</v-btn>
          <v-btn color="success" @click="sendInvitationSMSPayU"
            v-if="zaproszenie_show_payu && (zaproszenie_sms_payu == null || zaproszenie_sms_payu.status !== 0)">Wyślij</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <P1Verify :visitid="visitid" v-if="showVerify" :visible="showVerify" @close="showVerify = false"></P1Verify>
    <v-row>
      <v-col cols="12">
        <RefundDialog v-if="visible_new_refund" :max-refund="max_refund" :visible="visible_new_refund"
          @close="closeNewRefund" @save="saveNewRefund"></RefundDialog>
      </v-col>
    </v-row>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

  </v-dialog>

</template>

<script>
import { mapState, mapActions } from "vuex";
import swal from "sweetalert";
import { clientService, payUService } from "@/services/";
import { roomService } from "@/services/";
import { userService } from "@/services/";
import { visitService } from "@/services/";
import { therapistsService } from "@/services/";
import { ability } from "@/store/ability";
import TimePicker from "@/components/shared/TimePicker.vue";
import * as dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import VisitProcess from "./VisitProcess";
import MedicalVisitHistory from "../clients/MedicalVisitHistory";
import P1Verify from "@/components/visits/P1Verify";
import { settingsService } from "@/services";
import { voucheryService } from "@/services/vouchery.service";
import i18next from "i18next";
import { TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, Paragraph, BulletList, OrderedList, ListItem, Link, Blockquote, HardBreak, HorizontalRule, History } from 'tiptap-vuetify'
import RefundDialog from "@/components/payu/RefundDialog.vue";
import QuickAddClient from "../clients/QuickAddClient.vue";
import DatePicker from "@/components/shared/DatePicker.vue";
import VisitEditorAdditionalTherapists from "./VisitEditorAdditionalTherapists.vue";
import ClientSMS from "@/components/clients/ClientSMS.vue";
import RegularVisitDates from "./RegularVisitDates.vue";
import Problemy from "@/components/clients/Problemy.vue";
import ClientAttachments from "@/components/clients/ClientAttachments.vue";
import ClientSignatures from "@/components/clients/ClientSignatures.vue";
//import { Date } from "core-js";
export default {
  name: "VisitEditor",
  created() {
    //this.loadTherapists('');
  },
  data() {
    return {
      title: "",
      loading: false,
      visibility_class: "row",
      initialized: false,
      saving: false,
      startTime: null,
      endTime: null,
      oldStartTime: null,
      oldEndTime: null,
      date: null,
      fulldate: null,
      therapistId: null,
      roomId: 0,
      clientId: null,
      status: 0,
      paymentType: 0,
      payAmount: 0,
      process: null,
      patientPhone: null,
      notes: "",
      disabledClients: [],
      disabledRooms: [],
      recognition: "",
      recomendations: "",
      voucherPayAmount: 0,
      reserveId: 0,
      processing: false,
      sendOpinionSMS: false,
      paymentDateMenu: false,
      paymentDate: null,
      max_refund: 0,
      visible_new_refund: false,
      selected_order_id: 0,
      timeConfig: {
        enableTime: true,
        noCalendar: false,
        time_24hr: true,
        allowInput: true,
        defaultHour: 0
      },
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [Heading, {
          options: {
            levels: [1, 2, 3]
          }
        }],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak
      ],
      paymentHeaders: [
        { text: "Wartość", value: "payAmount", sortable: false },
        { text: "Sposób", value: "type", sortable: false },
        { text: "Data", value: "paymentDate", sortable: false },
        { text: "Akcje", value: "id", sortable: false }
      ],
      podsumowanieHeaders: [
        { text: "Nazwa zabiegu/wizyty", value: "nazwa", sortable: false },
        { text: "Podtyp zabiegu", value: "podtyp", sortable: false },
        { text: "Start wizyty", value: "start", sortable: false },
        { text: "Długość wizyty", value: "dlugoscWizyty", sortable: false },
        { text: "Cena", value: "cena", sortable: false },
        { text: "Terapeuta", value: "terapeuta", sortable: false },
      ],
      podsumowanie: [],
      editPaymentDialog: false,
      editPaymentAmount: 0,
      editPaymentType: 0,
      editPaymentId: 0,
      clientsList: [],
      payments: [],
      rooms: [],
      isLoadingClients: false,
      clientKeyword: null,
      therapistKeyword: null,
      active_tab: 0,
      therapists: [],
      dateMenu: false,
      TherapistDetails: null,
      readonly: false,
      visitid: 0,
      reasonDialog: false,
      reason: null,
      reasonNotes: null,
      smsData: null,
      addQuickClientDialog: false,
      notesForReception: null,
      isFromPortal: false,
      portalStatus: 0,
      portalLoading: false,
      disableAddPayment: false,
      quickAddPatientData: {
        name: null,
        surname: null,
        phone: null,
        zgoda_na_sms: false,
        description: null
      },
      quickClientSaving: false,
      isLoadingTherapists: false,
      allowToCheckTime: false,
      visitProcedures: [],
      visitConditions: [],
      showVerify: false,
      organizational_units: [],
      organizational_unit: null,
      organizational_unit_id: 0,
      wybrany_zabieg: null,
      zabieg_id: 0,
      zabieg_podtypid: 0,
      wybrany_podtyp: null,
      wybrany_typ_wizyty: null,
      showZaproszenieDialog: false,
      zaproszenie_sms: null,
      zaproszenie_sms_payu: null,
      zaproszenie_show_payu: false,
      obecny: false,
      obecny_text: 'Pacjent nieobecny',
      kredyt: false,
      limit_kredytu: 0,
      aktualne_saldo: 0,
      waznosc_kredytu: null,
      nie_wysylaj_sms: false,
      nie_wysylaj_sms_text: 'SMS potwierdzający będzie wysłany',
      pay_by_payu: false,
      voucherList: [],
      wybrany_voucher: null,
      visitShifts: [],
      cancelReason: null,
      statusSubType: null,
      //cancelReasons: ["Pacjent", "Terapeuta", "Placówka"],
      cancelSubtypes: [{ type: 1, name: "Terapeuta" }, { type: 2, name: "Recepcja" }, { type: 3, name: "Nieobecność usprawiedliowiona" }, { type: 4, name: "Nieobecność nieusprawiedliowiona" }],
      birthDate: null,
      age: null,
      editPaymentDateMenu: false,
      editPaymentDate: null,
      additionalTherapists: [],
      therapistCheck: null,
      regularVisit: false,
      regularVisitSelectedPeriod: null,
      regularVisitPeriods: [{
        name: "Codziennie",
        value: 1
      }, {
        name: "Co tydzień",
        value: 2
      }, {
        name: "Co 2 tygodnie",
        value: 3
      }, {
        name: "Co miesiąc",
        value: 4
      }
      ],
      periodEndDate: null,
      regularVisitDialog: false,
      regularVisitData: null,
      datesStatus: null,
      _previousRegularVisit: false,
      _previousRegularVisitSelectedPeriod: null,
      _previousPeriodEndDate: null,
    };
  },
  props: ["visitData", "visible", "zabieg", "zabiegi", "typywizyt", "hidevisithistory", "placowka"],
  methods: {
    ...mapActions("title", ["updateTitle"]),
    ...mapActions("alert", ["error", "success"]),
    ...mapActions("visits", ["saveVisit"]),
    updateAdditionalTherapists(newTherapists) {
      this.additionalTherapists = newTherapists;

    },
    showZaproszenieSMSPayU() {
      this.zaproszenie_show_payu = true
      this.showZaproszenieDialog = true
    },
    showZaproszenieSMS() {
      this.zaproszenie_show_payu = false
      this.showZaproszenieDialog = true
    },
    calculateBirthDateAndAge(pesel) {
      if (!/^\d{11}$/.test(pesel)) {
        this.birthDate = null;
        this.age = null;
        return;
      }

      const yearBase = parseInt(pesel.substring(0, 2), 10);
      const month = parseInt(pesel.substring(2, 4), 10);
      const day = parseInt(pesel.substring(4, 6), 10);

      let year;
      if (month > 80) {
        year = 1800 + yearBase;
      } else if (month > 60) {
        year = 2200 + yearBase;
      } else if (month > 40) {
        year = 2100 + yearBase;
      } else if (month > 20) {
        year = 2000 + yearBase;
      } else {
        year = 1900 + yearBase;
      }

      const correctedMonth = month % 20; // Usunięcie przesunięcia wieku
      this.birthDate = new Date(year, correctedMonth - 1, day);

      const today = new Date();
      this.age = today.getFullYear() - year;
      if (
        today.getMonth() < correctedMonth - 1 ||
        (today.getMonth() === correctedMonth - 1 && today.getDate() < day)
      ) {
        this.age--;
      }
    },
    closeNewRefund() {
      this.max_refund = 0
      this.selected_order_id = 0
      this.editPaymentId = 0
      this.visible_new_refund = false
    },
    saveNewRefund(data) {
      var orderId = this.selected_order_id
      var paymentId = this.editPaymentId
      this.selected_order_id = 0
      this.editPaymentId = 0
      this.max_refund = 0
      this.visible_new_refund = false


      payUService.refundPayment({ orderId: orderId, amount: data.refundAmount, reason: data.reason }).then(() => {
        const objIndex = this.payments.findIndex(
          obj => obj.id === paymentId
        );
        if (objIndex > -1) {
          let editedItem = this.payments[objIndex]
          editedItem.payURefunded = true
          Object.assign(this.payments[objIndex], editedItem)

        }
      }).catch((error) => {
        let err = error.response
        if (err.data != null && err.data.error && err.data.error.message) {
          this.showError(false, err.data.error.message)
        } else {
          this.showError(false, "Nie można zwrócić płatności")
        }
      })
    },
    refund(item) {
      this.editPaymentId = item.id
      this.selected_order_id = item.payUOrderId;
      this.max_refund = item.payAmount
      this.visible_new_refund = true
    },
    obecnoscChange() {
      let oldValue = !this.obecny
      visitService.PacjentObecnyNieobecny(this.visitid).then(() => {
        if (this.obecny)
          this.obecny_text = 'Pacjent obecny'
        else
          this.obecny_text = 'Pacjent nieobecny'
      }).catch(() => {
        this.obecny = oldValue
        if (this.obecny)
          this.obecny_text = 'Pacjent obecny'
        else
          this.obecny_text = 'Pacjent nieobecny'
        this.showError(false, 'Bład ustawiania obecności')
      })

    },
    payByPayuChange() {
      let oldValue = !this.pay_by_payu
      visitService.SetPayByPayu(this.visitid).then(() => {
      }).catch(() => {
        this.pay_by_payu = oldValue
        this.showError(false, 'Bład ustawiania płatności PayU')
      })
    },
    nieWysylajChange() {
      let oldValue = !this.nie_wysylaj_sms
      visitService.SetNieWysylajSMS(this.visitid).then(() => {
        if (this.nie_wysylaj_sms)
          this.nie_wysylaj_sms_text = 'SMS potwierdzający nie będzie wysłany'
        else
          this.nie_wysylaj_sms_text = 'SMS potwierdzający będzie wysłany'
      }).catch(() => {
        this.nie_wysylaj_sms = oldValue
        if (this.nie_wysylaj_sms)
          this.nie_wysylaj_sms_text = 'SMS potwierdzający nie będzie wysłany'
        else
          this.nie_wysylaj_sms_text = 'SMS potwierdzający będzie wysłany'
        this.showError(false, 'Bład ustawiania sms')
      })
    },
    handleSubmit(e) {
      this.active_tab = 0;
      if (this.startTime == null || this.startTime == "") {
        this.showError(false, "Nie określono godziny początkowej.");
        return;
      }
      if (this.endTime == null || this.endTime == "") {
        this.showError(false, "Nie określono godziny końcowej.");
        return;
      }
      if (this.therapistId == null || this.therapistId == 0) {
        this.showError(false, "Nie wybrano terapeuty.");
        return;
      }


      if (this.clientId == null || this.clientId == 0) {
        this.showError(false, "Nie wybrano pacjenta.");
        return;
      }
      let t = this.therapists.find(x => x.id == this.therapistId)
      if (t.disabled && t.reason != 'Harmonogram') {
        this.showError(false, 'Nie można zapisać wizyty z tym terapeutą.')
        return;
      }
      this.$validator.validateAll("mainForm").then(valid => {
        if (valid) {
          this.hide();


          if (this.visitid == 0) {

            if (t != null && t.reason == 'Harmonogram') {
              swal({
                title: "Niezgodnosć z hamornogramem.",
                text:
                  "Czy chcesz kontynuować? Wybrana data i godziny nie są zgodne z hamonogramem wybranego terapeuty.",
                icon: "warning",
                buttons: ["Nie", "Tak"],
                dangerMode: true
              }).then(confirmed => {
                if (confirmed) {
                  this.saveNewVisit(true);
                }
              });
            }
            else {
              this.saveNewVisit();
            }
          } else {
            this.updateVisit();
          }
          this.show()
        }
      });
    },
    hide() {
      this.visibility_class = "row scale-transition scale-out";
      this.saving = true;
    },
    show() {
      this.visibility_class = "row";
      this.saving = false;
    },
    showError(close, text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(value => {
        this.loading = false;
        if (close) {
          this.$emit("close");
        }
      });
    },
    getPaymentAmount(item) {
      if (item.type == 4) {
        if (item.voucher.typ == 2) {
          return item.payAmount.toFixed(2)
        }
        if (item.voucher.typ == 0) {
          return '1 wizyta'
        }
        if (item.voucher.typ == 1) {
          return item.voucherPayment.wykorzystane_minuty + ' minut'
        }
      } else {
        return item.payAmount.toFixed(2)
      }
    },
    getPaymentType(item) {
      switch (item.type) {
        case 0:
          return "Gotowką";
        case 1:
          return "Kartą";
        case 2:
          return "Przelewem";
        case 3:
          return "Kredyt";
        case 4:
          return "Voucher (" + item.voucher.nazwa + ")"
        case 6:
          return item.payURefunded ? "Płatnośc PayU zwrócona" : "PayU";
        case 5:
          return "Inne";
        default:
          return "Gotówką";
      }
    },
    getFormattedDate(val) {
      let dj = dayjs(val)
      if (dj != null) {
        return dj.format("DD-MM-YYYY HH:mm")
      } else {
        return val
      }
    },
    getFormattedDateWithoutTime(val) {
      let dj = dayjs(val)
      if (dj != null) {
        return dj.format("YYYY-MM-DD")
      } else {
        return val
      }
    },
    getSMSStatus(status) {
      if (status == 0)
        return 'Nowy';
      if (status == 1 || status == 2)
        return 'Wysłano';
      if (status == 3)
        return 'Błąd wysyłki';
      return '';
    },
    updateVisitPayment() {
      if (this.editPaymentAmount == 0) {
        this.showError(false, "Nie podano kwoty.");
        this.editPaymentAmount = 0;
        this.editPaymentType = 0;
        this.editPaymentId = 0;
        this.editPaymentDate = null;
        this.editPaymentDialog = false;
      } else {
        visitService
          .UpdatePayment({
            paymentAmount: this.editPaymentAmount,
            paymentType: this.editPaymentType,
            paymentId: this.editPaymentId,
            paymentDate: this.editPaymentDate // Pass the date
          })
          .then(resp => {
            const objIndex = this.payments.findIndex(
              obj => obj.id === this.editPaymentId
            );
            if (objIndex > -1) {
              this.payments[objIndex].type = this.editPaymentType;
              this.payments[objIndex].payAmount = this.editPaymentAmount;
              this.payments[objIndex].paymentDate = this.editPaymentDate; // Update local date
              this.editPaymentAmount = 0;
              this.editPaymentType = 0;
              this.editPaymentId = 0;
              this.editPaymentDate = null;
              this.editPaymentDialog = false;
              this.calcPaymentValue();
            }
          })
          .catch(e => {
            if (
              e.response != null &&
              e.response.data != null &&
              e.response.data.error != null
            ) {
              this.showError(false, e.response.data.error.message);
            } else {
              this.showError(false, "Nie można zapisać płatności");
            }
          });
      }
    },
    editPayment(id) {
      let pay = this.payments.find(x => x.id == id);
      if (pay != null) {
        this.editPaymentType = pay.type;
        this.editPaymentAmount = pay.payAmount;
        this.editPaymentId = id;

        this.editPaymentDate = dayjs(pay.paymentDate).format('YYYY-MM-DD') || null; // Set the date for editing

        this.editPaymentDialog = true;
      }
    },
    addPaymentVoucher() {
      this.loading = true;
      if (this.wybrany_voucher.typ == 2 && this.voucherPayAmount == 0) {
        this.showError(false, 'Podaj wartość do pobrania z vouchera.')
        return
      }

      visitService
        .AddPayment({
          visitId: this.visitid,
          paymentAmount: this.wybrany_voucher.typ == 2 ? this.voucherPayAmount : 0,
          paymentType: this.paymentType,
          voucherId: this.wybrany_voucher.id
        })
        .then(resp => {
          if (resp.data != null && resp.data.result != null) {
            let payment = resp.data.result;
            this.payments.push(payment);
            this.loading = false;
            this.wybrany_voucher = 0
            this.voucherPayAmount = 0
            this.calcPaymentValue();
            this.getClientVoucherList()
          } else {
            throw "Error zapisania płatności";
          }
        })
        .catch(e => {
          if (
            e.response != null &&
            e.response.data != null &&
            e.response.data.error != null
          ) {
            this.showError(false, e.response.data.error.message);
          } else {
            this.showError(false, "Nie można zapisać płatności");
          }
          this.loading = false;
        });
    },
    addPayment() {
      this.loading = true;
      visitService
        .AddPayment({
          visitId: this.visitid,
          paymentAmount: this.payAmount,
          paymentType: this.paymentType,
          paymentDate: this.paymentDate
        })
        .then(resp => {
          if (resp.data != null && resp.data.result != null) {
            let payment = resp.data.result;
            this.payments.push({
              type: payment.type,
              payAmount: payment.payAmount,
              id: payment.id
            });
            this.loading = false;
            this.payAmount = 0;
            this.paymentType = 0;
            this.paymentDate = null;
            this.calcPaymentValue();
          } else {
            throw "Error zapisania płatności";
          }
        })
        .catch(e => {
          if (
            e.response != null &&
            e.response.data != null &&
            e.response.data.error != null
          ) {
            this.showError(false, e.response.data.error.message);
          } else {
            this.showError(false, "Nie można zapisać płatności");
          }
          this.loading = false;
        });
    },
    updateVisit() {
      var startDate = this.date + " " + this.startTime;
      var endDate = this.date + " " + this.endTime;
      let additionalTherapistsToSave = [];

      this.additionalTherapists.forEach(t => {
        additionalTherapistsToSave.push({ id: t.id, therapistVisitTypeId: t.typWizytyId });
      });
      this.processing = true
      visitService
        .UpdatePatientvisitDetails({
          startTime: startDate,
          endTime: endDate,
          therapistId: this.therapistId,
          clientId: this.clientId,
          roomId: this.roomId == null ? 0 : this.roomId,
          notes: this.notes,
          status: this.status,
          //paymentType: this.paymentType,
          //payAmount: this.payAmount,
          recognition: this.recognition,
          recommendations: this.recomendations,
          organizationalUnitId: this.organizational_unit != null ? this.organizational_unit.id : 0,
          id: this.visitid,
          zabiegId: this.wybrany_zabieg != null ? this.wybrany_zabieg.id : 0,
          zabiegPodtypId: this.wybrany_podtyp != null ? this.wybrany_podtyp.id : 0,
          typWizytyTerapeutyId: this.wybrany_typ_wizyty != null ? this.wybrany_typ_wizyty.id : 0,
          additionalTherapists: additionalTherapistsToSave,
          regularVisit: this.regularVisit,
          regularVisitCheckDateStatuses: this.datesStatus
        })
        .then(resp => {
          if (resp.data.result.regularVisitCheckResult != null && resp.data.result.regularVisitCheckResult.visitDatesWithException != null &&
            resp.data.result.regularVisitCheckResult.visitDatesWithException.length > 0) {
            this.showError(false, 'Wizyta cykliczna wymaga aktualizacji niektórych dat. Zaktualizuj daty wizyt i spróbuj ponownie.');
            this.regularVisitData = resp.data.result.regularVisitCheckResult
            this.regularVisitDialog = true
            return;
          }

          this.success("Zapisano");
          this.processing = false
          this.$emit("close");
        })
        .catch(e => {
          this.loading = false;
          this.processing = false
          if (
            e.response != null &&
            e.response.data != null &&
            e.response.data.error != null
          ) {
            this.showError(false, e.response.data.error.message);
          } else {
            this.showError(false, "Nie można zapisać wizyty");
          }
        });
    },
    quickAddClient() {
      this.quickAddPatientData.name = null;
      this.quickAddPatientData.surname = null;
      this.quickAddPatientData.phone = null;
      this.quickAddPatientData.zgoda_na_sms = false;
      this.quickAddPatientData.description = null;
      this.addQuickClientDialog = true;
    },
    saveNewVisit(harmonogram = false) {
      var startDate = this.date + " " + this.startTime;
      var endDate = this.date + " " + this.endTime;
      this.processing = true


      let additionalTherapistsToSave = [];

      this.additionalTherapists.forEach(t => {
        additionalTherapistsToSave.push({ id: t.id, therapistVisitTypeId: t.typWizytyId });
      });
      let isRegularVisit = this.regularVisitSelectedPeriod != null && this.regularVisit && this.periodEndDate != null;

      visitService
        .create({
          startTime: startDate,
          endTime: endDate,
          therapistId: this.therapistId,
          clientId: this.clientId,
          roomId: this.roomId == null ? 0 : this.roomId,
          notes: this.notes,
          organizationalUnitID: this.organizational_unit != null ? this.organizational_unit.id : 0,
          zabiegId: this.wybrany_zabieg != null ? this.wybrany_zabieg.id : 0,
          podTypZabieguID: this.wybrany_podtyp != null ? this.wybrany_podtyp.id : 0,
          typWizytyTerapeutyId: this.wybrany_typ_wizyty != null ? this.wybrany_typ_wizyty.id : 0,
          pomin_harmonogram: harmonogram,
          rezerwaId: this.reserveId,
          additionalOutpostId: this.placowka != null ? this.placowka.id : 0,
          additionalTherapists: additionalTherapistsToSave,
          regularVisit: isRegularVisit,
          regularVisitPeriod: isRegularVisit ? this.regularVisitSelectedPeriod.value : null,
          regularVisitEndDate: isRegularVisit ? this.periodEndDate : null,
          regularVisitCheckDateStatuses: this.datesStatus
        })
        .then((result) => {
          this.processing = false
          if (result.data.result.id == 0 && result.data.result.regularVisitCheckResult != null && result.data.result.regularVisitCheckResult.visitDatesWithException != null &&
            result.data.result.regularVisitCheckResult.visitDatesWithException.length > 0) {
            this.showError(false, 'Wizyta cykliczna wymaga aktualizacji niektórych dat. Zaktualizuj daty wizyt i spróbuj ponownie.');
            this.checkRegularVisit();
            return;
          }
          this.saveVisit({
            date: this.date,
            startTime: this.startTime,
            endTime: this.endTime
          });


          this.visitid = result.data.result.id

          this.getVisitDetails(result.data.result.message)
          //this.$emit("close");
        })
        .catch(e => {
          this.processing = false
          this.loading = false;

          if (
            e.response != null &&
            e.response.data != null &&
            e.response.data.error != null
          ) {
            this.showError(false, e.response.data.error.message);
          } else {
            this.showError(false, "Nie można zapisać wizyty");
          }
        });
    },
    closeForm() {
      this.$emit("close");
    },
    calcPaymentValue() {
      this.payAmount = 0;
      this.disableAddPayment = false
      if (this.therapistId > 0 && this.zabieg_id == 0) {
        let t = this.therapists.find(x => x.id == this.therapistId);

        if (t != null) this.payAmount = t.pay;
      }
      if (this.zabieg_id > 0) {
        let z = this.zabiegi.find(x => x.id == this.zabieg_id)
        if (z != null) this.payAmount = z.cena
      }
      if (this.podsumowanie !== null && this.podsumowanie.length > 0) {
        this.payAmount = this.podsumowanie_suma
      }
      if (this.payments != null) {
        let totalPay = 0;
        this.payments.forEach(x => (totalPay += (x.payAmount < 0 ? x.payAmount * -1 : x.payAmount)));
        this.payAmount -= totalPay;
        if (this.payAmount < 0) this.payAmount = 0;
      }
      this.voucherPayAmount = this.payAmount
      let paymentList = this.payments.filter(x => x.type == 4)
      paymentList.forEach(x => {
        if (x.voucher.typ == 0 || x.voucher.typ == 1) {
          this.disableAddPayment = true
        }
      })
      if (this.wybrany_typ_wizyty) {
        this.payAmount = this.wybrany_typ_wizyty.cena
      }
    },
    getStatusDescription() {
      if (this.statusSubType != 0) {
        switch (this.statusSubType) {
          case 1:
            return 'Odwołana przez pracownika'
          case 2:
            return 'Odwołana przez placówkę'
          case 3:
            return 'Nieobecność usprawiedliowiona'
          case 4:
            return 'Nieobecność nieusprawiedliowiona'
        }
      }
      switch (this.status) {
        case 0:
          return 'Nowa'
        case 1:
          return 'Potwierdzona'
        case 2:
          return 'Anulowana'
        case 3:
          return 'Zakończona'
        default:
          return ''
      }
    },
    getVisitDetails(message) {
      this.loading = true;
      this.smsData = null
      this.processing = true
      visitService
        .GetPatientVisitDetails(this.visitid)
        .then(resp => {
          if (resp != null && resp.data != null && resp.data.result != null) {
            var visit = resp.data.result;
            var dj = dayjs(visit.startTime);
            this.fulldate = visit.startTime;
            this.date = dj.format("YYYY-MM-DD");
            this.startTime = dj.format("HH:mm");
            this.endTime = dayjs(visit.endTime).format("HH:mm");
            this.visitShifts = visit.visitShifts
            this.sendOpinionSMS = visit.client.sentOpinionSMS
            this.clientsList.push({
              id: visit.clientID,
              name: visit.client.name,
              surname: visit.client.surname,
              full_text: visit.client.name + ' ' + visit.client.surname + (visit.client.pesel != null && visit.client.pesel != '' ? ' ' + visit.client.pesel : '') + (visit.client.phone != null && visit.client.phone != '' ? ' ' + visit.client.phone : ''),
              pesel: visit.client.pesel,
              therapist: visit.clientTherapistID,
              description: visit.client.description,
              phone: visit.client.phone,
              disabled: false
            });

            /*this.therapists.push({
                id: visit.therapistID,
                name: visit.therapistName,
                pay: visit.therapistRate
            });*/
            this.clientId = visit.clientID;
            this.notes = visit.notes;
            //                    this.payAmount = visit.payAmount
            //this.paymentType = visit.paymentType
            this.recognition = visit.recognition;
            this.recomendations = visit.recommendations;
            this.process = visit.process;
            this.notesForReception = visit.notesForReception;
            this.isFromPortal = visit.isFromPortal;
            this.portalStatus = visit.portalStatus;
            this.roomId = visit.roomID;
            this.therapistId = visit.therapistID;
            this.regularVisit = visit.regularVisit;
            if (visit.additionalTherapists != null) {
              //let therapists = this.therapists.filter(t => visit.additionalTherapists.includes(t.id));

              let therapists = [];
              visit.additionalTherapists.forEach(t => {
                let therapist = this.therapists.find(x => x.id == t.id);
                if (therapist != null) {
                  if (t.therapistVisitTypeId && t.therapistVisitTypeId > 0) {
                    var visitType = this.typywizyt.find(x => x.id == t.therapistVisitTypeId);

                    if (visitType != null) {
                      const therapistWithVisitType = {
                        ...therapist,
                        typWizyty: visitType.nazwa,
                        typWizytyId: visitType.id
                      };

                      therapists.push(therapistWithVisitType);
                    }
                  }
                  else {
                    therapists.push(therapist);
                  }
                }
              });

              this.additionalTherapists = therapists;
            }
            this.status = visit.status;
            this.payments = visit.payments;
            this.patientPhone = visit.clientPhone
            this.visitProcedures = visit.procedures
            this.visitConditions = visit.conditions
            this.obecny = visit.obecny
            this.cancelReason = visit.cancelReason
            this.statusSubType = visit.statusSubtype
            if (this.obecny)
              this.obecny_text = 'Pacjent obecny'
            else
              this.obecny_text = 'Pacjent nieobecny'
            this.nie_wysylaj_sms = visit.nie_wysylaj_sms
            this.pay_by_payu = visit.payByPayU
            if (this.nie_wysylaj_sms)
              this.nie_wysylaj_sms_text = 'SMS potwierdzający nie będzie wysłany'
            else
              this.nie_wysylaj_sms_text = 'SMS potwierdzający będzie wysłany'
            //let ou = this.organizational_units.find(x => x.id == visit.organizationalUnitId)
            //this.organizational_unit = ou

            this.organizational_unit_id = visit.organizationalUnitId
            this.zabieg_id = visit.zabiegId
            this.zabieg_podtypid = visit.zabiegPodtypId
            this.zaproszenie_sms = visit.zaproszenie_sms
            this.zaproszenie_sms_payu = visit.zaproszenie_sms_payu
            this.kredyt = visit.kredyt
            this.aktualne_saldo = visit.aktualne_saldo
            this.waznosc_kredytu = visit.waznosc_kredytu
            this.limit_kredytu = visit.limit_kredytu
            if (visit.payments == null) this.payments = [];
            if (this.zabieg_id > 0) {
              let zz = this.filteredzabiegi.find(x => x.id == this.zabieg_id)
              this.wybrany_zabieg = zz
              if (this.zabieg_podtypid) {
                setTimeout(() => {
                  let pt = this.filteredpodtypy.find(x => x.id == this.zabieg_podtypid)

                  this.wybrany_podtyp = pt
                }, 150);

              }
            }

            if (visit.typWizytyTerapeutyId > 0) {
              let t = this.filteredtypywizyt.find(x => x.id == visit.typWizytyTerapeutyId)
              this.wybrany_typ_wizyty = t
            }
            this.getPodsumowanie();
            this.calcPaymentValue();
            this.checkVisitTime(true)
            this.loadOrganizationalUnits()
            this.getClientVoucherList()
            if (message && message.length > 0) {
              swal({
                title: "Rezerwa",
                text: message,
                icon: "warning",
                buttons: ["Zapisz wizyte", "Odwołaj wizyte"],
                dangerMode: true
              }).then(confirmed => {
                if (confirmed) {
                  this.cancelVisit()
                }
              });
            }
          } else {
            throw "error";
          }
          this.loading = false;
          this.processing = false
        })
        .catch(e => {
          this.loading = false;
          this.processing = false
          this.showError(true, "Nie można pobrać danych o wizycie");
        });
      if (ability.can('do', 'POKO_InformacjeSMS')) {
        this.loading = true
        visitService.GetVisitSMSStatus(this.visitid).then(resp => {
          if (resp.data != null && resp.data.result != null) {
            this.smsData = resp.data.result
          } else {
            this.smsData = null
          }
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      }
    },
    dateTimeFormat(val) {
      if (val) {
        return dayjs(val).format('DD-MM-YYYY HH:mm')
      }
      return ''
    },
    dateFormat(val) {
      if (val) {
        return dayjs(val).format('DD-MM-YYYY')
      }
      return ''
    },
    getPodsumowanie() {
      //this.clientId
      //this.fulldate
      if (this.features.Fizykoterapia) {
        visitService.getPodsumowaniePacjenta({
          Client: this.clientId,
          Data: this.fulldate
        }).then(result => {
          this.podsumowanie = result.data.result
          this.calcPaymentValue()
        }).catch(() => {
          this.showError(true, "Nie można pobrać podsumowania wizyt dla pacjenta.");
        })
      }
    },
    getClientValues(val) {
      this.isLoadingClients = true;
      clientService
        .getAll({ query: val, page: 1, limit: 20, sorting: "surname" })
        .then(data => {
          data.data.result.items.forEach(item => {
            if (!this.clientsList.find(x => x.id === item.id)) {
              let name = item.name + " " + item.surname;
              if (item.pesel != null && item.pesel != "")
                name = name + "/" + item.pesel;
              if (item.phone != null && item.phone != "")
                name = name + " tel: " + item.phone;
              this.clientsList.push({
                id: item.id,
                name: item.name,
                surname: item.surname,
                pesel: item.pesel,
                therapist: item.therapistID,
                full_text: item.name + ' ' + item.surname + (item.pesel != null && item.pesel != '' ? ' ' + item.pesel : '') + (item.phone != null && item.phone != '' ? ' ' + item.phone : ''),
                disabled: false,
                description: item.description,
                phone: item.phone
              });
            }
          });
          this.checkClients()
          this.isLoadingClients = false;
        })
        .catch(e => {
          this.isLoadingClients = false;
          this.showError(true, "Nie można pobrać listy klientów.");
        });
    },
    loadTherapists(val) {
      this.isLoadingTherapists = true;
      therapistsService
        .getAll({ query: val, page: 1, limit: 1000 })
        .then(response => {
          if (
            response.data != null &&
            response.data.result != null &&
            response.data.result.items != null
          ) {

            response.data.result.items.forEach((r, index) => {
              if (!this.therapists.find(x => x.id === r.id)) {
                let insert = true;
                if (!this.visitid && this.placowka) {
                  if (r.additionalOutposts && r.additionalOutposts.length > 0) {
                    if (r.additionalOutposts.indexOf(this.placowka.id) < 0) {
                      insert = false;
                    }
                  }
                }
                if (insert) {
                  if (this.visitid > 0) {
                    this.therapists.push({
                      id: r.id,
                      name: r.name + " " + r.surname,
                      pay: r.rate,
                      disabled: r.isActive ? false : true
                    });
                  }
                  else {
                    if (r.isActive) {
                      this.therapists.push({
                        id: r.id,
                        name: r.name + " " + r.surname,
                        pay: r.rate,
                        disabled: r.isActive ? false : true
                      });
                    }
                  }
                }
              }
            });
            // Auto-select therapist if only one available and creating a new visit
            if (!this.visitid && this.therapists.length === 1 && !this.therapistId) {
              this.therapistId = this.therapists[0].id;
            }
            this.isLoadingTherapists = false;
            if (this.visitid > 0) {
              this.getVisitDetails();
            }
          } else {
            throw "error pobierania terapeutów";
          }
        })
        .catch(e => {
          this.isLoadingTherapists = false;
          this.showError(true, "Nie można pobrać listy terapeutów.");
        });
    },
    loadRooms() {
      this.loading = true;
      roomService
        .getAllRooms()
        .then(response => {
          if (
            response.data != null &&
            response.data.result != null &&
            response.data.result.items != null
          ) {
            response.data.result.items.forEach(item => {
              this.rooms.push({ value: item.id, text: item.name, placowkaId: item.placowkaId });
            });
            this.checkRooms()
            this.loading = false;
          }
        })
        .catch(e => {
          this.loading = false;
          this.showError(true, "Błąd pobierania gabinetów");
        });
    },
    loadOrganizationalUnits(setTherapistDetails = false) {
      if (this.features.IntegracjaP1) {
        this.loading = true

        settingsService.GetOrganizationalUnits(0).then((result) => {
          this.organizational_units = result.data.result

          if (this.organizational_unit_id > 0 && this.organizational_units) {
            this.organizational_unit = this.organizational_units.find(x => x.id == this.organizational_unit_id)
          }

          if (setTherapistDetails && this.therapistId > 0) {
            this.getSetTherapistDetails(this.therapistId)
          }
          else {
            this.loading = false
          }
        }).catch(() => {
          this.loading = false
          this.showError(true, "Błąd pobierania komórek organizacyjnych");
        })
      }
    },
    clearFormData() {
      this.TherapistDetails = null;
      this.therapistId = null;
      this.clientId = null;
      this.roomId = null;
      this.visitid = 0;
      this.readonly = false;
      this.active_tab = 0;
      this.notes = null;
      this.status = 0;
      this.patientPhone = null;
      this.errors.clear();
    },
    callCloseVisit(opinion) {
      visitService
        .CloseVisit(this.visitid, opinion)
        .then(resp => {
          if (resp.data == null || !resp.data.success) {
            throw "Błąd zamykania wizyty";
          } else {
            this.success("Zamknięto");
            this.$emit("close");
          }
        })
        .catch(e => {
          console.log(e);
          this.error("Nie można zamknąć wizyty");
        });
    },
    closeVisit() {
      swal({
        title: "Czy na pewno?",
        text:
          "Zamkniecie wizyty spowoduje zablokowanie edycji. Zamknąć można tylko wizytę która się odbyła.",
        icon: "warning",
        buttons: ["Nie", "Tak"],
        dangerMode: true
      }).then(confirmed => {
        if (confirmed) {

          if (!this.sendOpinionSMS && this.settings.szablon_sms_opinia && this.settings.szablon_sms_opinia.length > 0) {
            swal({
              title: "Opinia sms",
              text:
                "Czy wysłać SMS z prośbą o opinie?",
              icon: "warning",
              buttons: ["Nie", "Tak"],
              dangerMode: true
            }).then(c => {
              if (c) {
                this.callCloseVisit(true)
              }
              else {
                this.callCloseVisit(false)
              }
            });
          }
          else {
            this.callCloseVisit(false)
          }


        }
      });
    },
    openVisit() {
      visitService
        .OpenVisit(this.visitid)
        .then(resp => {
          if (resp.data == null || !resp.data.success) {
            throw "Błąd otwierania wizyty";
          } else {
            this.success("Otwarto");
            this.getVisitDetails();
          }
        })
        .catch(e => {
          console.log(e);
          this.error("Nie można otworzyć wizyty");
        });
    },
    confirmPortalVisit() {
      swal({
        title: "Potwierdzenie wizyty z portalu",
        text: "Czy na pewno chcesz potwierdzić tę wizytę z portalu pacjenta?",
        icon: "warning",
        buttons: ["Anuluj", "Potwierdź"],
        dangerMode: false
      }).then(confirmed => {
        if (confirmed) {
          this.portalLoading = true;
          visitService
            .ConfirmPortalVisit(this.visitid)
            .then(resp => {
              if (resp.data && resp.data.result) {
                this.success("Wizyta z portalu została potwierdzona");
                this.portalStatus = 2; // CONFIRMED
                this.status = 0; // NEW
                this.getVisitDetails();
              } else {
                throw "Błąd potwierdzenia wizyty";
              }
            })
            .catch(e => {
              console.log(e);
              this.error("Nie można potwierdzić wizyty z portalu");
            })
            .finally(() => {
              this.portalLoading = false;
            });
        }
      });
    },
    cancelPortalVisit() {
      swal({
        title: "Odrzucenie wizyty z portalu",
        text: "Podaj powód odrzucenia:",
        icon: "warning",
        content: {
          element: "input",
          attributes: {
            placeholder: "Powód odrzucenia (opcjonalny)",
            type: "text"
          }
        },
        buttons: ["Anuluj", "Odrzuć"],
        dangerMode: true
      }).then(reason => {
        if (reason !== null) {
          this.portalLoading = true;
          visitService
            .CancelPortalVisit(this.visitid, reason || null)
            .then(resp => {
              if (resp.data && resp.data.result) {
                this.success("Wizyta z portalu została odrzucona");
                this.portalStatus = 3; // CANCELLED
                this.$emit("close");
              } else {
                throw "Błąd odrzucenia wizyty";
              }
            })
            .catch(e => {
              console.log(e);
              this.error("Nie można odrzucić wizyty z portalu");
            })
            .finally(() => {
              this.portalLoading = false;
            });
        }
      });
    },
    confirmVisit() {
      swal({
        title: "Czy na pewno?",
        text: "Czy na pewno ta wizyta została potwierdzona?",
        icon: "warning",
        buttons: ["Nie", "Tak"],
        dangerMode: true
      }).then(confirmed => {
        if (confirmed) {
          visitService
            .ConfirmVisit(this.visitid).then(resp => {
              if (resp.data == null || !resp.data.success) {
                throw "Błąd potwierdzenia wizyty";
              } else {
                this.success("Potwierdzono");
                this.$emit("close");

              }
            })
            .catch(e => {
              console.log(e);
              this.error("Nie można potwierdzić wizyty");
            });
        }
      });

    },
    deletePayment(payid) {
      swal({
        title: "Czy na pewno?",
        text: "Czy na pewno chcesz usunąć tę płatność?",
        icon: "warning",
        buttons: ["Nie", "Tak"],
        dangerMode: true
      }).then(confirmed => {
        if (confirmed) {
          visitService
            .DeletePayment(payid)
            .then(resp => {
              let p = this.payments.find(x => x.id == payid);
              if (p != null) {
                this.payments = this.payments.filter(itm => itm.id != p.id);
              }
              this.calcPaymentValue();
              this.getClientVoucherList()
            })
            .catch(ex => {
              this.error("Nie można usunąć płatności");
            });
        }
      });
    },
    cancelVisit() {
      swal({
        title: "Czy na pewno?",
        text:
          "Czy na pewno chcesz anulować tę wizytę?",
        icon: "warning",
        buttons: ["Nie", "Tak"],
        dangerMode: true
      }).then(confirmed => {
        if (confirmed) {
          this.reason = null;
          this.reasonNotes = null;
          this.reasonDialog = true;
          //console.log(reason)
        }
      });
    },
    saveCancel() {
      visitService
        .CancelVisit(this.visitid, this.reasonNotes, this.reason.type)
        .then(resp => {
          this.$emit("close");
        })
        .catch(resp => {
          if (
            resp.response != null &&
            resp.response.data != null &&
            resp.response.data.error != null
          ) {
            this.showError(false, resp.response.data.error.message);
          } else {
            this.showError(false, "Błąd anulowanie wizyty");
          }
        });
    },

    saveQuickClient(quickClient) {
      this.addQuickClientDialog = false
      this.clientsList.push({
        id: quickClient.id,
        name: quickClient.name,
        surname: quickClient.surname,
        pesel: quickClient.pesel,
        therapist: quickClient.therapistID,
        full_text: quickClient.name + ' ' + quickClient.surname + (quickClient.pesel != null && quickClient.pesel != '' ? ' ' + quickClient.pesel : '') + (quickClient.phone != null && quickClient.phone != '' ? ' ' + quickClient.phone : ''),
        disabled: false,
        description: quickClient.description,
        phone: quickClient.phone
      });
      this.clientId = quickClient.id;

    },
    checkVisitTimeTypWizytyTerapeuty() {
      if (this.date && this.startTime && this.endTime) {
        let startDate = this.date + " " + this.startTime;
        let endDate = this.date + " " + this.endTime;
        visitService.CheckVisitTimeStatus({
          dateStart: startDate,
          dateEnd: endDate,
          zabiegi: this.zabieg,
          visit_id: this.visitid
        }).then(resp => {
          if (resp && resp.data && resp.data.result) {
            let result = resp.data.result

            if (result.therapistCheck && result.therapistCheck.length > 0) {
              this.therapistCheck = result.therapistCheck
              let found = null
              result.therapistCheck.forEach(itm => {
                if (itm.therapistId == this.therapistId) {
                  found = itm
                }
              })
              if (found != null && found.type != 'Harmonogram') {
                this.showError(false, "Uwaga ten typ wizyty koliduje czasowo z kalendarzem wybranego terapeuty.")
                this.startTime = this.oldStartTime
                this.endTime = this.oldEndTime
                this.wybrany_typ_wizyty = null
              }

            }

          }
        }).catch(() => {
          this.showError(false, "Błąd sprawdzania daty i godziny");
        })
      }
    },
    checkVisitTime(force) {

      this.therapists.forEach(itm => {
        itm.disabled = false
        itm.reason = ''
      })
      this.disabledClients = []
      this.disabledRooms = []


      if (!this.allowToCheckTime && !force) return

      if (this.date && this.startTime && this.endTime) {
        let startDate = this.date + " " + this.startTime;
        let endDate = this.date + " " + this.endTime;

        visitService.CheckVisitTimeStatus({
          dateStart: startDate,
          dateEnd: endDate,
          zabiegi: this.zabieg,
          visit_id: this.visitid
        }).then(resp => {
          if (resp && resp.data && resp.data.result) {
            let result = resp.data.result

            if (result.therapistCheck && result.therapistCheck.length > 0) {
              result.therapistCheck.forEach(itm => {
                let t = this.therapists.find(x => x.id == itm.therapistId);

                if (t) {

                  t.disabled = itm.type === 'Harmonogram' ? false : true
                  t.reason = itm.type
                  if (this.therapistId > 0) {
                    let s = this.therapistId
                    this.therapistId = 0
                    this.therapistId = s
                  }
                }
              })
            }
            if (result.roomCheck && result.roomCheck.length > 0) {
              this.disabledRooms = [...result.roomCheck]
            }
            if (result.clientCheck && result.clientCheck.length > 0) {
              this.disabledClients = [...result.clientCheck]
            }
            this.checkClients()
            this.checkRooms()
          }
          if (force)
            this.allowToCheckTime = true
        }).catch(() => {
          this.showError(false, "Błąd sprawdzania daty i godziny");
        })
      }
    },
    checkRooms() {
      if (this.rooms && this.rooms.length > 0) {
        this.rooms.forEach(itm => {
          itm.disabled = false
        })
        if (this.disabledRooms && this.disabledRooms.length > 0) {
          this.disabledRooms.forEach(rd => {
            let room = this.rooms.find(itm => itm.value == rd)
            if (room)
              room.disabled = true
          })
        }
      }
    },
    checkClients() {
      if (this.clientsList && this.clientsList.length > 0) {
        this.clientsList.forEach(itm => {
          itm.disabled = false
        })
        if (this.disabledClients && this.disabledClients.length > 0) {
          this.disabledClients.forEach(cd => {
            let client = this.clientsList.find(itm => itm.id == cd)
            if (client)
              client.disabled = true
          })
        }
      }
    },
    async sendInvitationSMS() {
      let shouldSend = true;
      if (this.zaproszenie_sms != null) {
        shouldSend = await swal({
          title: "Uwaga",
          text: "Czy na pewno chcesz wysłać zaproszenie ponownie?",
          icon: "warning",
          buttons: ["Anuluj", "Tak"],
          dangerMode: true
        });
      }
      if (!shouldSend)
        return;
      visitService.SendInvitationVisit({ visitId: this.visitid, payU: false }).then(result => {
        this.zaproszenie_sms = result.data.result
      }).catch(error => {
        let err = error.response
        if (err.data != null && err.data.error && err.data.error.message) {
          this.showError(false, err.data.error.message)
        }
        else {
          this.showError(false, 'Bład wysyłki zaproszenia')
        }
      })
    },
    async sendInvitationSMSPayU() {
      let shouldSend = true;
      if (this.zaproszenie_sms_payu != null) {
        shouldSend = await swal({
          title: "Uwaga",
          text: "Czy na pewno chcesz wysłać zaproszenie PayU ponownie?",
          icon: "warning",
          buttons: ["Anuluj", "Tak"],
          dangerMode: true
        });
      }
      if (!shouldSend)
        return;
      visitService.SendInvitationVisit({ visitId: this.visitid, payU: true }).then(result => {
        this.zaproszenie_sms_payu = result.data.result
      }).catch(error => {
        let err = error.response
        if (err.data != null && err.data.error && err.data.error.message) {
          this.showError(false, err.data.error.message)
        }
        else {
          this.showError(false, 'Bład wysyłki zaproszenia')
        }
      })
    },
    getSetTherapistDetails(newTherapist) {
      this.loading = true;
      therapistsService
        .getDetails(newTherapist)
        .then(resp => {
          if (
            resp.data != null &&
            resp.data.success &&
            resp.data.result != null
          ) {
            let therapist = resp.data.result;

            if (therapist.mainOrganizationalUnitID > 0) {

              let orgUT = this.organizational_units.find(x => x.id == therapist.mainOrganizationalUnitID)
              if (orgUT != null)
                this.organizational_unit = orgUT;
            }
            this.TherapistDetails = therapist;
            if (!this.therapists.find(x => x.id == newTherapist)) {
              this.therapists.push({
                id: newTherapist,
                name: therapist.name + " " + therapist.surname,
                pay: therapist.rate,
                disabled: false
              })
            }
            if (this.startTime != null && therapist.visitTime > 0 && this.wybrany_typ_wizyty == null) {
              var datetime = new Date(
                "1970-01-01T" + this.startTime + ""
              );

              this.endTime = dayjs(datetime)
                .add(therapist.visitTime, "minute")
                .format("HH:mm");
            }
          }
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    },
    getClientVoucherList() {
      this.loading = true
      voucheryService.getClientVouchers(this.clientId).then(result => {
        this.voucherList = result.data.result
        this.loading = false
      }).catch(() => {
        this.showError(false, 'Bład pobierania voucherów dla klienta')
        this.loading = false
      })
    },
    getTypOpis(typ) {
      switch (typ) {
        case 0:
          return 'Wizyta';
        case 1:
          return 'Czas';
        case 2:
          return 'Kwota';
      }
      return ''
    },
    getWartosc(typ) {
      switch (typ) {
        case 0:
          return item.ilosc_wizyt + ' wizyt';
        case 1:
          return item.czas_minuty + ' minut';
        case 2:
          return item.kwota_do_wykorzystania + ' zł';
      }
      return ''
    },
    getWykorzystanieOpis(typ) {
      switch (typ) {
        case 0:
          return 'Ilość wizyt';
        case 1:
          return 'Ilość minut';
        case 2:
          return 'Kwota';
      }
    },
    getWykorzystaneWartosci(item) {

      switch (item.typ) {
        case 0:
          return item.wykorzystana_ilosc + '/' + item.ilosc_wizyt;
        case 1:
          return item.wykorzystane_minuty + '/' + item.czas_minuty;
        case 2:
          return item.wykorzystana_kwota + 'zł /' + item.kwota_do_wykorzystania + " zł";
      }
    },
    calculateAllHours() {
      if (this.wybrany_typ_wizyty == null) return

      let dlugosc = this.wybrany_typ_wizyty.dlugosc_wizyty
      if (this.wybrany_podtyp != null && this.wybrany_podtyp.dlugoscWizyty > 0) {
        dlugosc = this.wybrany_podtyp.dlugoscWizyty
      }
      if (dlugosc > 0) {
        if (this.startTime != null) {

          this.oldStartTime = this.startTime
          this.oldEndTime = this.endTime

          var datetime = new Date(
            "1970-01-01T" + this.startTime
          );

          this.endTime = dayjs(datetime)
            .add(dlugosc, "minute")
            .format("HH:mm");
          this.checkVisitTimeTypWizytyTerapeuty()
        }
      }
    },
    async checkRegularVisit() {
      if (this.therapistId == null || this.therapistId == 0) {
        this.showError(false, "Nie wybrano terapeuty.");
        return;
      }


      if (this.clientId == null || this.clientId == 0) {
        this.showError(false, "Nie wybrano pacjenta.");
        return;
      }
      let additionalTherapistsToSave = [];

      this.additionalTherapists.forEach(t => {
        additionalTherapistsToSave.push({ id: t.id, therapistVisitTypeId: t.typWizytyId });
      });
      var startDate = this.date + " " + this.startTime;
      var endDate = this.date + " " + this.endTime;
      let data = {
        startTime: startDate,
        endTime: endDate,
        therapistId: this.therapistId,
        clientId: this.clientId,
        endDate: this.periodEndDate,
        roomId: this.roomId,
        period: this.regularVisitSelectedPeriod.value,
        additionalTherapists: additionalTherapistsToSave,
        regularVisitCheckDateStatuses: this.datesStatus
      }
      this.loading = true;
      let result = await visitService.checkRegularVisit(data)

      if (result.status == 200) {
        this.loading = false;
        this.regularVisitData = result.data.result
        this.regularVisitDialog = true
      }
      else {
        this.loading = false;
        this.showError(false, result.error.message)
      }
    },
    onCloseRegularVisitDialog() {
      this.regularVisitDialog = false
      this.regularVisitData = null
    },
    onSaveRegularVisit(result) {
      this.datesStatus = result
      this.regularVisitDialog = false
      this.regularVisitData = null
    },
    confirmResetDatesStatus() {
      swal({
        title: "Uwaga",
        text: "Zmiana ustawień wizyty cyklicznej spowoduje reset poprzedniej weryfikacji. Czy chcesz kontynuować?",
        icon: "warning",
        buttons: ["Anuluj", "Kontynuuj"],
        dangerMode: true
      }).then(confirmed => {
        if (confirmed) {
          this.datesStatus = null;
        } else {
          // Revert the changes
          this.$nextTick(() => {
            if (this.regularVisit !== this._previousRegularVisit) {
              this.regularVisit = this._previousRegularVisit;
            }
            if (this.regularVisitSelectedPeriod !== this._previousRegularVisitSelectedPeriod) {
              this.regularVisitSelectedPeriod = this._previousRegularVisitSelectedPeriod;
            }
            if (this.periodEndDate !== this._previousPeriodEndDate) {
              this.periodEndDate = this._previousPeriodEndDate;
            }
          });
        }
      });
    },
  },
  mounted() {
    //this.loadTherapists()
    this.loadRooms();
    //this.loadOrganizationalUnits();
    //this.startDateTime = this.visitData.StartTime
    //this.endDateTime = this.visitData.EndTime
    dayjs.extend(customParseFormat);
    //this.cancelReasons[0] = i18next.t('FE_KLIENT')
    this.cancelSubtypes[0].name = i18next.t('FE_PRACOWNIK')
  },
  updated() {
  },
  components: {
    RefundDialog,
    P1Verify,
    MedicalVisitHistory,
    TimePicker,
    VisitProcess,
    TiptapVuetify,
    QuickAddClient,
    DatePicker,
    VisitEditorAdditionalTherapists,
    ClientSMS,
    RegularVisitDates,
    Problemy,
    ClientAttachments,
    ClientSignatures
  },
  computed: {
    ...mapState('featuresModule', ['features']),
    ...mapState('companySettingsModule', ['settings']),
    isAttachementsEnabled: function () {
      return this.features && this.features.ZalacznikiPoko
    },
    selectedClientName: function () {
      let c = (this.clientsList || []).find(x => x.id === this.clientId);
      return c ? ((c.name || '') + ' ' + (c.surname || '')).trim() : '';
    },
    fullTherapistListForAdditionalTherapists: function () {
      //remove selected therapist from list
      let ltherapists = this.therapists.filter(x => x.id != this.therapistId)
      return ltherapists.map(x => ({
        id: x.id,
        name: x.name,
        disabled: x.disabled,
        reason: x.reason
      }))
    },
    calcMinTime: function () {
      if (this.startTime) {
        let dlugosc = 0;
        if (this.wybrany_typ_wizyty != null) {
          dlugosc = this.wybrany_typ_wizyty.dlugosc_wizyty
          if (this.wybrany_podtyp != null && this.wybrany_podtyp.dlugoscWizyty > 0) {
            dlugosc = this.wybrany_podtyp.dlugoscWizyty
          }
        }
        return dayjs(this.startTime, 'HH:mm').add(dlugosc, 'minute').format('HH:mm');
      }
      return null
    },
    availableRooms: function () {
      if (this.placowka) {
        return this.rooms.filter(x => x.placowkaId == this.placowka.id)
      }
      else {
        return this.rooms
      }
    },
    showModal: {
      get: function () {
        if (!this.visible) {
          this.clearFormData();

          this.$validator.reset();
        }
        return this.visible;
      },
      set: function (value) {
        if (!value) {
          this.$emit("close");
        }
      }
    },
    zmiana_pracownika_enabled: function () {
      return this.visitid != 0 && !ability.can('do', 'POKO_Wizyty_Zmiana_Pracownika')
    },
    filteredzabiegi: function () {
      let zab = this.zabiegi.map(obj => ({ ...obj, disabled: !obj.aktywny }))
      if (this.placowka) {
        zab = zab.filter(x => x.additionalOutpostId == this.placowka.id)
      }
      return zab
    },
    filteredpodtypy: function () {
      if (this.wybrany_zabieg.podtypy == null) {
        this.wybrany_podtyp = null
        return []
      }
      return this.wybrany_zabieg.podtypy.map(obj => ({ ...obj, disabled: !obj.aktywny }))
    },
    filteredtypywizyt: function () {
      if (this.therapistId > 0) {
        let lst = []
        lst = this.typywizyt.map(obj => ({ ...obj, disabled: !obj.aktywna }))
        return lst.filter(x => x.terapeuta_id == this.therapistId)
      }
      return []
    },
    podsumowanie_suma: function () {
      if (this.podsumowanie != null && this.podsumowanie.length > 0) {
        let suma = 0
        this.podsumowanie.forEach(x => suma += x.cena)
        return suma
      }
      return 0
    }
  },
  watch: {
    clientKeyword(val) {
      if (val) {
        this.getClientValues(val);
      }
    },
    therapistKeyword(val) {
      if (val) {
        this.loadTherapists(val);
      }
    },
    date(val) {
      if (val) {
        this.checkVisitTime(false)
      }
    },
    startTime(val) {
      if (val) {
        this.calculateAllHours()
        this.checkVisitTime(false)
      }
    },
    endTime(val) {
      if (val) {

        this.checkVisitTime(false)
      }
    },
    visitData: {
      immediate: true,
      handler(newData) {
        if (newData != null) {
          if (newData.Id !== undefined && newData.Id != null && newData.Id > 0) {
            this.visitid = newData.Id;
            this.readonly = true;
            this.loadTherapists('');
          } else {
            this.loadTherapists('');

            var dj = dayjs(newData.StartTime);
            this.date = dj.format("YYYY-MM-DD");
            this.startTime = dj.format("HH:mm");
            this.endTime = dayjs(newData.EndTime).format("HH:mm");
            this.clearFormData();

            if (newData.type == 'Day') {
              this.therapistId = newData.therapistID
              this.roomId = newData.roomID
            }
            if (newData.zabiegID && newData.zabiegID > 0) {
              this.zabieg_id = newData.zabiegID
              let zz = this.filteredzabiegi.find(x => x.id == this.zabieg_id)
              this.wybrany_zabieg = zz

              if (zz.dlugoscWizyty > 0) {
                var tmpDatetime = new Date(
                  "1970-01-01T" + this.startTime
                );

                this.endTime = dayjs(tmpDatetime)
                  .add(zz.dlugoscWizyty, "minute")
                  .format("HH:mm");
              }
            }
            if (newData.typWizytyTerapeutyId && newData.typWizytyTerapeutyId > 0) {
              //this.typWizytyTerapeutyId = newData.typWizytyTerapeutyId
              let t = this.filteredtypywizyt.find(x => x.id == newData.typWizytyTerapeutyId)

              this.wybrany_typ_wizyty = t

            }
            if (newData.reserveId && newData.reserveId > 0) {
              this.reserveId = newData.reserveId
            }
            if (newData.client) {
              let name = newData.client.name + " " + newData.client.surname;
              if (newData.client.pesel != null && newData.client.pesel != "")
                name = name + "/" + newData.client.pesel;
              this.clientsList.push({
                id: newData.client.id,
                name: name,
                therapist: 0,
                disabled: false
              });
              this.clientId = newData.client.id;
            }
            this.checkVisitTime(true)
            this.loadOrganizationalUnits(true)
          }
        }
      }
    },
    clientId: function (newClient, oldClient) {
      var client = this.clientsList.find(x => x.id === newClient);
      if (client != null && this.visitid == 0) {
        if (client.therapist && client.therapist > 0) {
          let t = this.therapists.find(x => x.id == client.therapist)
          if (!t && !t.disabled) {
            this.therapistId = client.therapist;
          }
        }
      }
      if (client != null && client.pesel) {
        this.calculateBirthDateAndAge(client.pesel)
      }
      else {
        this.calculateBirthDateAndAge(null)
      }
    },
    wybrany_zabieg: function (newZabieg) {
      this.wybrany_podtyp = null
      if (newZabieg && this.visitid == 0) {
        if (this.startTime != null && newZabieg.dlugoscWizyty > 0) {
          var datetime = new Date(
            "1970-01-01T" + this.startTime
          );
          this.endTime = dayjs(datetime)
            .add(newZabieg.dlugoscWizyty, "minute")
            .format("HH:mm");
        }
      }
    },
    wybrany_podtyp: function (newPodTyp) {
      if (newPodTyp && this.visitid == 0) {
        if (this.startTime != null && newPodTyp.dlugoscWizyty > 0) {
          var datetime = new Date(
            "1970-01-01T" + this.startTime
          );
          this.endTime = dayjs(datetime)
            .add(newPodTyp.dlugoscWizyty, "minute")
            .format("HH:mm");
        }
      }
    },

    therapistId: function (newTherapist, oldTherapist) {
      this.TherapistDetails = null;
      if (newTherapist && newTherapist > 0 && this.visitid == 0) {
        this.getSetTherapistDetails(newTherapist)
      }
    },
    wybrany_typ_wizyty: {
      immediate: true,
      handler: function (typ, oldval) {
        if (typ == null) return
        if (typ.dlugosc_wizyty > 0) {
          if (this.startTime != null) {

            this.oldStartTime = this.startTime
            this.oldEndTime = this.endTime

            var datetime = new Date(
              "1970-01-01T" + this.startTime
            );

            this.endTime = dayjs(datetime)
              .add(typ.dlugosc_wizyty, "minute")
              .format("HH:mm");

            this.checkVisitTimeTypWizytyTerapeuty()
          }
        }
      }
    },
    paymentType(newVal, oldVal) {
      if (newVal !== 2) {
        this.paymentDate = null;
      }
    },
    editPaymentType(newVal, oldVal) {
      if (newVal !== 2) {
        this.editPaymentDate = null;
      }
    },
    regularVisit(newVal, oldVal) {
      if (oldVal !== undefined && this.datesStatus && (this.datesStatus.excludedDates.length > 0 || this.datesStatus.resolvedExceptions.length > 0)) {
        this.confirmResetDatesStatus();
      }
      this._previousRegularVisit = newVal;
    },

    regularVisitSelectedPeriod(newVal, oldVal) {
      if (oldVal !== undefined && this.datesStatus && (this.datesStatus.excludedDates.length > 0 || this.datesStatus.resolvedExceptions.length > 0)) {
        this.confirmResetDatesStatus();
      }
      this._previousRegularVisitSelectedPeriod = newVal;
    },

    periodEndDate(newVal, oldVal) {
      if (oldVal !== undefined && this.datesStatus && (this.datesStatus.excludedDates.length > 0 || this.datesStatus.resolvedExceptions.length > 0)) {
        this.confirmResetDatesStatus();
      }
      this._previousPeriodEndDate = newVal;
    },
  }
};
</script>

<style scoped>
.simple_table {
  border: solid 1px #DDEEEE;
  border-collapse: collapse;
  border-spacing: 0;
  font: normal 13px Arial, sans-serif;
}

.simple_table thead th {
  background-color: #DDEFEF;
  border: solid 1px #DDEEEE;
  color: #336B6B;
  padding: 10px;
  text-align: left;
  text-shadow: 1px 1px 1px #fff;
}

.simple_table tbody td {
  border: solid 1px #DDEEEE;
  color: #333;
  padding: 10px;
  text-shadow: 1px 1px 1px #fff;
}

.gap-2 {
  gap: 8px;
  /* Adjust as needed */
}
</style>
